import { createStyles, Theme } from '@material-ui/core';
import { errorColor, errorHoverColor, errorContrastText } from '../../theme';

const styles = (theme: Theme) => createStyles({
  fullscreenWrapper: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1300, // Выше чем у AppBar (обычно 1100)
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    // Убрали медиа-запрос [theme.breakpoints.up('sm')], так как fullscreen должен работать
    // не только для xs (ширина < 600px), но и когда высота < 600px (горизонтальная ориентация)
    // независимо от ширины экрана
  },
  actions: {
    display: 'flex',
    height: '84px',
    padding: '16px 23px 16px 24px',
    boxShadow: '0 -3px 6px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#ffffff',
    justifyContent: 'space-between',
    zIndex: 20,
    alignItems: 'center', // Выравнивание по центру
    gap: theme.spacing(1.5), // Gap между кнопками для экранов, где они рядом
    [theme.breakpoints.only('xs')]: {
      padding: '12px 16px',
      paddingBottom: `12px`, // Учитываем safe-area
      height: 'auto',
      minHeight: 'auto',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      // Фиксируем кнопки внизу экрана на мобильных
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      '& > button': {
        width: '100%',
        margin: '0 !important',
        height: '40px !important', // Принудительно применяем высоту
      },
    },
    [theme.breakpoints.only('sm')]: {
      padding: '14px 20px',
      paddingBottom: `14px`, // Учитываем safe-area
      height: 'auto',
      minHeight: 'auto',
      gap: theme.spacing(1.5),
      // Фиксируем кнопки внизу экрана на планшетах
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      '& > button': {
        height: '44px !important', // Принудительно применяем высоту
      },
    },
  },
  formWrap: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    height: '100%',
    minHeight: 'calc(100vh - 64px)',
    [theme.breakpoints.down(465)]: {
      minHeight: '100vh',
      height: '100vh',
      overflow: 'hidden',
    },
  },
  // header: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   height: 55,
  //   padding: '0px 24px 0 6px',
  //   boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
  //   backgroundColor: '#ffffff',
  //   zIndex: 20,
  //   [theme.breakpoints.down(465)]: {
  //     alignItems: 'flex-start',
  //     flexDirection: 'column',
  //     height: '100%',
  //     paddingBottom: 24,
  //   },
  // },

  headerTitleWrap: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: 250,
    minWidth: 234,
    width: '100%',
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  justHeaderTitle: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 12,
    minHeight: 48,
    [theme.breakpoints.down(465)]: {
      paddingLeft: 24,
    },
  },

  content: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    minHeight: 0,
    [theme.breakpoints.down(600)]: {
      marginBottom: '100px'
    },
    [theme.breakpoints.down(465)]: {
      flexDirection: 'column',
      overflow: 'hidden',
      flex: 1,
      minHeight: 0,
      // Добавляем отступ снизу для фиксированных кнопок
      // Высота кнопок: ~40px каждая + gap + padding = ~100px
      marginBottom: `100px`,
      overflowY: 'auto', // Разрешаем скролл контента
    },
    [theme.breakpoints.only('sm')]: {
      // Добавляем отступ снизу для фиксированных кнопок на планшетах
      // Высота кнопок: ~44px + gap + padding = ~72px
      marginBottom: `72px`,
      overflowY: 'auto', // Разрешаем скролл контента
    },
  },
  btnStyle: {
    width: '100%',
    height: 52,
    fontSize: 16,
    padding: '16px 24px',
    [theme.breakpoints.only('xs')]: {
      height: '40px !important',
      fontSize: '14px !important',
      padding: '12px 16px !important',
      minHeight: '40px !important',
    },
    [theme.breakpoints.only('sm')]: {
      // width остается '100%' как на десктопе
      height: '44px !important',
      fontSize: '15px !important',
      padding: '14px 18px !important',
      minHeight: '44px !important',
    },
  },
  btnEdit: {
    color: errorContrastText,
    backgroundColor: errorColor,
    '&:hover': {
      backgroundColor: errorHoverColor,
    },
  },
  banquetError: {
    width: '100%',
    height: 52,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
  },
  banquetErrorText: {
    maxWidth: 370,
    fontFamily: 'GolosTextWebMedium',
  },
});

export default styles;
